import React from 'react';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';

const useStyles = makeStyles({
    thank:{
        textAlign: 'center',
        width:'80%',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
  })

const Ops = _ => {
    const classes = useStyles()
    return <div className={classes.thank}>
        <h1 >Oooooooops!</h1>
        <h2 >We cannot find the page that you are looking for.</h2>
        <p>To go ACE Call &amp; Collect, click the button below.</p>
        <Button variant="contained" color='primary'
          onClick={() => {
               window.location.href = 'https://call-collect.acehardware.ph/'; 
               return null;
          }}>
            Call &amp; Collect
        </Button>
    </div>
}

export default Ops;
